import { ComponentType, ReactNode } from 'react';
import get from '../accessors/get';
import findChildByType from './#findChildByType';

const getPropByType = <
Type extends ComponentType<{ children?: any }> & { type: Symbol }
>(children: ReactNode, Component: Type, propName: string, defaultValue: unknown) => {
  const component = findChildByType(children, Component);

  return get(component, `props[${propName}]`, defaultValue);
};

/**
 * @visibleName getPropByType
 * @component
 */
export default getPropByType;
